export * from './artist.detail.model';



// WEBPACK FOOTER //
// ./src/models/artist/index.ts